/**
 * Provide convenient API for Prime Launcher.
 * Use abstract data provider for data retrieving and handle it for Prime Launcher purposes.
 *
 * @module launcher.api.provider
 *
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

var RESOLUTION   = screen.height,
    uniqueItemID = 1,
    intentContext,
    index;


/**
 * Play radio stations via sending intent.
 *
 * @param {Object[]} allStationsQueue - all retrieved radio stations to play
 * @param {Object} item - resource to open
 */
function playRadioStation ( allStationsQueue, item ) {
    var intentData = {
        action: 'play',
        mime: 'content/audio',
        data: {
            uri:      item.url,
            title:    item.name,
            solution: item.solution || 'auto',
            mediaId:  item.id
        },
        context: intentContext,
        events: {
            error: function () {
                intentContext = null;
            },
            hide: function () {
                intentContext = null;
            },
            close: function () {
                intentContext = null;
            },
            prev: function () {
                index = allStationsQueue.indexOf(item);

                playRadioStation(allStationsQueue, allStationsQueue[--index % allStationsQueue.length]);
            },
            next: function () {
                index = allStationsQueue.indexOf(item);

                playRadioStation(allStationsQueue, allStationsQueue[++index % allStationsQueue.length]);
            }
        }
    };

    // delete intent events depending on file position in queue, disable "prev" on the first one and "next" on the last
    if ( !index ) {
        delete intentData.events.prev;
    }

    if ( index === allStationsQueue.length - 1 ) {
        delete intentData.events.next;
    }

    core.intent(intentData, function ( error, context ) {
        if ( !error ) {
            intentContext = context;
        }
    });
}


module.exports = function ( config, callback ) {
    var gettextWrapper = require('mag-gettext');

    gettextWrapper.load({
        name: core.environment.language,
        path: config.path + 'lang'
    }, function () {
        var dataProvider    = require('./data.provider'),
            Emitter         = require('cjs-emitter'),
            _               = gettextWrapper.gettext,
            contentProvider = new Emitter(),
            launcherAPI     = config.api,
            layout          = launcherAPI.layouts.static,
            geometry        = launcherAPI.geometry.square,
            setup           = {
                // how many channels send to Prime Launcher (max)
                channelsAmount: 10,
                moreButton: {
                    id:       ++uniqueItemID,
                    layout:   layout,
                    geometry: geometry,
                    data: {
                        name: _('See more'),
                        icon: {
                            normal: config.path + 'img/' + RESOLUTION + '/see.more.normal.png',
                            active: config.path + 'img/' + RESOLUTION + '/see.more.active.png'
                        }
                    },
                    runApp: true
                    /*onClick: function () {
                        core.intent({
                            action: 'radio:open',
                            events: {}
                        }, function ( error ) {
                            if ( error ) {
                                console.log(error);
                            }
                        });
                    }*/
                }
            };


        /**
         * Content search.
         *
         * @param {Object} config - configuration for search
         * @param {string} config.query - query search request
         * @param {Function} callback - which called when content is ready
         */
        contentProvider.search = function ( config, callback ) { // eslint-disable-line
            // @TODO: query data and invoke `callback(error, ContentItem[]);`
        };


        // collect data for Prime Launcher on start
        dataProvider.getRadioChannels({favorite: false}, function ( error, result ) {
            var radioChannels;

            if ( error ) {
                /*--------------------------
                 Here and in all such cases... if first argument (error) is object (or something truthy) it's the signal
                 to Prime Launcher to supress plugin output, even content string doesn't show
                --------------------------*/

                callback(error);
            } else {
                try {
                    if ( Array.isArray(result.data) ) {
                        radioChannels = result.data
                            .map(function ( item ) {
                                return {
                                    id:       ++uniqueItemID,
                                    layout:   layout,
                                    geometry: geometry,
                                    data: {
                                        name:     item.name,
                                        favorite: item.favorite,
                                        /*id:       item.id,
                                        date:     item.number,
                                        url:      item.url,
                                        solution: item.solution,*/
                                        icon: {
                                            normal: config.path + 'img/' + RESOLUTION + '/content.item.normal.png',
                                            active: config.path + 'img/' + RESOLUTION + '/content.item.active.png'
                                        }
                                    },
                                    onClick: function () {
                                        playRadioStation(result.data, item);
                                    }
                                };
                            })
                            .sort(function ( channel1, channel2 ) {
                                if ( channel1.data.favorite && !channel2.data.favorite ) {
                                    return -1;
                                } else if ( !channel1.data.favorite && channel2.data.favorite ) {
                                    return 1;
                                }

                                return 0;
                            })
                            .slice(0, setup.channelsAmount);

                        callback(null, {
                            provider: contentProvider,
                            data: radioChannels.length ? radioChannels.concat(setup.moreButton) : []
                        });
                    } else {
                        callback(true);
                    }
                } catch ( error ) {
                    callback(error);
                }
            }
        });
    });
};
